export const languages = [
  'en_US',
  'zh_CN',
  'zh_HK',
  'th_TH',
  'fil_PH',
  'es_ES',
  'ja_JP',
  'pt_PT',
  'vi_VN',
  'fr_FR',
  // 'tr_TR',
  // 'de_DE',
  'ru_RU',
  'it_IT',
] as const
export type TLanguages = (typeof languages)[number]
